// extracted by mini-css-extract-plugin
export default {"type":"home_type__r+o+G","b":"home_b__a-5QO","t":"home_t__cGo8b"};